import { UserApi } from "../../../Shared/Constants/api";
import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { parseResponseError } from "../../../Shared/Utils/errorUtils";

export const getUsersApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${UserApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
  }
};
